import { useEffect, useState } from "react"
import Shoot from "../../Scan/shoot"
import ToothSelector from "../../Scan/toothSelector"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import { generateSteps } from "../../Scan/steps"
import { isScanComplete, nextCaptureIndex } from "../../../Utils/scanProgress"

const Scan = () => {
    const navigate = useNavigate()
    const { images } = useSelector((state) => state.fullScan);
    // cameraSide affects only the demo image/tips, never the titles, so the default is fine here.
    const steps = generateSteps()
    const [activeImageSide, setImageSide] = useState(() => nextCaptureIndex(steps, images) ?? 0)
    const [isToothPicker, setToothPicker] = useState(false)

    useEffect(() => {
        if (!localStorage.getItem("usertpi") || localStorage.getItem("isScanCompleted")) {
            navigate(`/${localStorage.getItem("company")}/${localStorage.getItem("cameraSide")}`)
        }
        // Gate on WHICH images exist, not on images.length - a duplicate used to satisfy
        // the old `images.length >= 6` check with a step still missing.
        if (isScanComplete(steps, images)) {
            setToothPicker(true)
        }

    }, [activeImageSide])




    return (
        <div className="h-full">
            {
                isToothPicker ?
                    <ToothSelector setImageSide={setImageSide} setToothPicker={setToothPicker} /> :
                    <Shoot activeImageSide={activeImageSide} setToothPicker={setToothPicker} quickScan={false} setImageSide={setImageSide} />
            }
        </div>
    )
}

export default Scan